import taxAuthorityService from './taxAuthorityService';

const init = () => {
  taxAuthorityService.init();
};

export default { init };
